(function () {
    'use strict';

    angular
        .module('sodCommon')
        .directive('sodEmitEvent', sodEmitEvent);

    function sodEmitEvent(lodash, GaService) {
        return {
            restrict: 'A',
            scope: {
                eventName: '=',
                eventData: '=?',
                label: '=?',
                eventModel: "=?"
            },
            controllerAs: 'emitCtrl',
            bindToController: true,
            controller: sodEmitEventCtrl,
            // template: '<a ng-bind-html="emitCtrl.label" ng-class="emitCtrl.domClass" ng-click="emitCtrl.captureClick($event)"></a>',
            link: function(scope, elem, attrs) {
                var emitCtrl = scope.emitCtrl;
                if (!lodash.isEmpty(emitCtrl.label)) {
                    elem.html(emitCtrl.label);
                }

                elem.on('click', function(e) {
                    e.preventDefault();
                    console.log('sod-emit-event');
                    var event = lodash.get(emitCtrl, 'eventName', null);
                    var eventType = typeof event;

                    switch (eventType) {
                        case "object":
                            scope.$emit(event.name, lodash.get(emitCtrl, 'eventData', null));
                            GaService.addEvent(event, scope.eventModel);
                            break;
                        default:
                            scope.$emit(event, lodash.get(emitCtrl, 'eventData', null));
                            break;
                    }
                })
            }
        };
    }

    function sodEmitEventCtrl($scope) {
    }
})();